/* ALPHAMAN — minimal theme JS */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-nav-toggle]');
  if (t) {
    var nav = document.getElementById('main-nav');
    if (nav) {
      var open = nav.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
  var thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    var main = document.getElementById('pdp-main-image');
    if (main) { main.src = thumb.dataset.full || thumb.src; }
  }
});
